import { render, staticRenderFns } from "./Storages.vue?vue&type=template&id=0cdef6b0&"
import script from "./Storages.vue?vue&type=script&lang=js&"
export * from "./Storages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports